import { render } from "./BrandingGrid.vue?vue&type=template&id=25f7edaf&scoped=true&ts=true"
import script from "./BrandingGrid.vue?vue&type=script&lang=ts"
export * from "./BrandingGrid.vue?vue&type=script&lang=ts"

import "./BrandingGrid.vue?vue&type=style&index=0&id=25f7edaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f7edaf"]])

export default __exports__